import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Otc from '@/pages/Otc';
import CryptoTokenIntroduction from './pages/CryptoTokenIntroduction';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #0f0f23;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <AppContainer>
          <Header />
          <MainContent>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/otc" element={<Otc />} />
              <Route
                path="/CryptoTokenIntroduction"
                element={<CryptoTokenIntroduction />}
              />
            </Routes>
          </MainContent>
          <Footer />
        </AppContainer>
      </Router>
    </I18nextProvider>
  );
}

export default App;
